<template>
    <div class="recently-viewed" v-if="logs.length > 0">
        <div class="recently-viewed__header">
            <h2 class="recently-viewed__title">
                Recently Viewed
            </h2>
        </div>

        <ul>
            <li v-for="(item, index) in filteredLogs" :key="index">
                <button @click="handleSelection(item)" class="btn-option">
                    <module-icon :name="item.sub_module" class="icon" />
                    <span class="module-summary">
                        <span class="title">
                            {{ item.text }}
                        </span>
                        <span class="module">
                            {{ capitalizeFirstLetter(item.sub_module) }}
                        </span>
                    </span>
                </button>
            </li>
        </ul>
    </div>
</template>
<script>
import ModuleIcon from "@/module/layout/module-icon";
import recentLog from "@/mixins/recent-log";

export default {
    name: "TabPanelSectionRecentLog",
    components: { ModuleIcon },
    mixins: [recentLog],
    data() {
        return {
            logs: []
        };
    },
    computed: {
        isDialogOpen() {
            return this.$store.state.isGlobalSearchDialogOpen;
        }
    },
    watch: {
        async isDialogOpen(newVal) {
            if (newVal) {
                this.logs = await this.getLogs();
            }
        }
    },
    methods: {
        handleSelection(log) {
            this.goToPage(log);
            this.$emit("result-click");
        }
    }
};
</script>

<style lang="scss" scoped>
$vet-text-subtlest: #626f86;
$vet-background-neutral-subtle-hovered: #091e420f;
$vet-border-focused: #388bff;

.recently-viewed {
    padding: 4px 0;

    ul {
        padding: 0;
        list-style: none;
    }
}

.recently-viewed__header {
    max-height: 32px;
    margin-bottom: 0.375rem;
}

.recently-viewed__title {
    margin-top: 0;
    padding: 0 20px;
    font-size: 13px;
    font-weight: 500;
    color: #626f86;
}

button.btn-option {
    display: flex;
    gap: 8px;
    width: 100%;
    padding: 6px 20px 4px;
    background-color: transparent;
    text-align: start;
    border: 0;

    &:focus-visible {
        outline: 2px solid $vet-border-focused;
        outline-offset: -2px;
    }

    &:hover {
        background-color: $vet-background-neutral-subtle-hovered;
    }

    .icon {
        width: 18px;
        height: 18px;
        margin-top: 1px;
    }

    .module-summary {
        display: flex;
        flex-direction: column;
    }

    .title {
        font-weight: 500;
    }

    .module {
        font-size: 12px;
        color: $vet-text-subtlest;
    }
}
</style>
